import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  CircularProgress,
} from "@mui/material";

const ConfirmationModal = ({
  open,
  handleClose,
  title,
  message,
  selectedUser,
  onConfirm,
  actionLoadingText,
  ActionBtnText,
  loading,
}) => {
  if (!selectedUser) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 500,
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 1, borderRadius: 1 }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          sx={{
            borderRadius: 1,
            backgroundColor: "#dc3545",
            "&:hover": {
              backgroundColor: "#FD0606",
            },
          }}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? actionLoadingText : ActionBtnText}
          {loading && (
            <CircularProgress color="error" size={18} sx={{ ml: 1 }} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
